<template>
<div>
  <div class="col-sm-12" v-if="submitPending">
    přihlašování...
  </div>
  <div class="col-sm-12 error-box" v-if="displayError">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    {{ displayError }}
  </div>
</div>
</template>
<script>
import SessionResource from '../backend-resources/session-resource'

export default {
  name: 'token-login-component',
  data () {
    return {
      displayError: '',
      submitPending: false,
      customerInfo: null
    }
  },
  methods: {
    submitToken () {
      this.submitPending = true
      this.customerInfo = null
      let sr = new SessionResource()
      sr.createByToken(this.$route.params.token).then((response) => {
        this.submitPending = false
        this.customerInfo = response.data
        this.$store.commit('loginSuccess', this.customerInfo)
        this.$emit('after-login')
        // this.$router.push('/services')
        // this.$emit('load-cash-overdue')
      })
      .catch((error) => {
        this.submitPending = false
        if (error.response && error.response.status === 401) {
          this.displayError = 'Neplatný odkaz'
        } else if (error.response && error.response.status === 410) {
          this.displayError = 'Platnost odkazu pro přihlášení již vypršela.'
        } else if (error.response && error.response.status) {
          this.displayError = error.response.status + ' ' + error.response.statusText
        } else {
          this.displayError = error.toString()
        }
        this.customerInfo = null
        this.$store.commit('loginFailure', this.customerInfo)
      })
    }
  },

  created: function () {
    if (this.$route.params.token !== '') this.submitToken()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// TokenLogin.vue?cb23d64e